import { MouseEvent } from 'react';

import { FileType } from 'types';
import { Icon } from 'components/icon';
import { EllipsisText } from 'components/ellipsis-text';
import { Image, isBrowserImage } from 'components/image';

import * as Styles from './styles';
import { DropZoneContentProps } from './types';

export const DropZoneContent = ({
  onView,
  previewSrc,
  file: dropFile,
}: DropZoneContentProps) => {
  const { src, file } = dropFile || {};
  const { name, type } = file || {};
  // A picked photo previews only when every browser can draw it; a HEIC/HEIF
  // (iPhone original, also from Windows Chrome without a MIME type, D6)
  // shows as a file, like a PDF, never a broken image (the same rule as
  // components/image, FIX-OPS-UPLOAD-TYPES).
  const isImage =
    Boolean(type?.includes(FileType.Image)) &&
    (typeof src !== 'string' ||
      !src.startsWith('data:') ||
      isBrowserImage(src));
  const imageSrc = previewSrc === undefined ? src : previewSrc || undefined;

  const title = src ? (
    (name ?? type ?? '')
  ) : (
    <>
      Drag your file here, or <span>browse</span>
    </>
  );

  // The drop zone opens the file picker on any click inside it, so View
  // stops the click there; Replace lets it through.
  const view = (event: MouseEvent) => {
    event.stopPropagation();
    onView?.();
  };
  const image = isImage ? <Image clickable alt={src} src={imageSrc} /> : null;

  return (
    <Styles.DropContainer withoutBg={isImage}>
      {onView && image ? (
        <Styles.ViewArea onClick={view}>{image}</Styles.ViewArea>
      ) : (
        image
      )}

      {/* Over a photo the name sits in a strip along the bottom, never on
          the picture itself; a PDF or HEIC keeps the icon and name. */}
      <Styles.Wrapper $overImage={isImage} $withActions={!!onView && !!src}>
        {isImage ? null : src && file ? <Icon.FileFilled /> : <Icon.Image />}
        <h4>
          <EllipsisText>{title}</EllipsisText>
        </h4>
        {onView && src ? (
          <Styles.Actions>
            <button type="button" onClick={view}>
              View
            </button>
            <button type="button">Replace</button>
          </Styles.Actions>
        ) : null}
      </Styles.Wrapper>
    </Styles.DropContainer>
  );
};
